import DSMobileSeparator, { MobileSeparatorWithSchema } from './Separator.js';

export { MobileSeparatorWithSchema, DSMobileSeparator };
// export default DSMobileSeparator;
